// ==angular== //
import { NgModule,Injector } from '@angular/core';
import { BrowserModule} from '@angular/platform-browser';
import { BrowserAnimationsModule} from '@angular/platform-browser/animations';

//import { HttpModule } from '@angular/http';
import { HttpClientModule } from '@angular/common/http';
import {FormsModule,ReactiveFormsModule} from '@angular/forms';
import { Title } from '@angular/platform-browser';

// Import components
import { AppComponent } from './app.component';
import { BaseComponent }  from './share/component/base.component';
// Loading Component
import { LoadingComponent } from './share/component/loading.component';
import { PopConfirmComponent } from './share/component/pop-confirm.component';

// Page Component
import { HomeComponent }  from './component/home/home.component';
import { SearchComponent }  from './component/search/search.component';
import { AreaComponent }  from './component/area/area.component';
import { SortComponent }  from './component/sort/sort.component';
import { ActivityComponent }  from './component/activity/activity.component';
import { ActivityListComponent }  from './component/activity/activitylist.component';
//Member Component
import { SignupComponent }  from './component/member/signup.component';
import { SignTimeComponent }  from './component/member/signTime.component';
import { SignCheckComponent }  from './component/member/signCheck.component';
import { ContactComponent }  from './component/member/contact.component';
import { ContactEditComponent }  from './component/member/contactEdit.component';
import { SignSuccessComponent }  from './component/member/signSuccess.component';
import { ReserveComponent }  from './component/member/reserve.component';
import { MybuyerComponent }  from './component/member/mybuyer.component';
import { HistoryComponent }  from './component/member/history.component';

import { ErrorComponent }  from './component/basepage/error.component';
import { NotFoundComponent }  from './component/basepage/notFound.component';

// Share Module
import { ShareModule } from './share/share.module';
// Pipe
//import { PipeModule } from '../app/share/pipe/pipe.module';
// Directuve
import { UrlHrefDirective } from './share/directive/hrefDirective'
// const Components
const APP_CONTAINERS = [
  BaseComponent,
  HomeComponent,
  ErrorComponent,
  NotFoundComponent,
  SearchComponent,
  AreaComponent,
  SortComponent,
  ActivityComponent,
  ActivityListComponent,
  SignupComponent,
  SignTimeComponent,
  SignCheckComponent,
  ContactComponent,
  ContactEditComponent,
  SignSuccessComponent,
  ReserveComponent,
  MybuyerComponent,
  HistoryComponent
];
import { AppRoutingModule } from './app-routing.module';
@NgModule({
  imports: [
    // ==angular== //
    //HttpModule,
    BrowserModule,
    BrowserAnimationsModule,
    HttpClientModule,
    AppRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    ShareModule,
    //PipeModule,
  ],
  declarations: [
    AppComponent,
    ...APP_CONTAINERS,
    LoadingComponent,
    PopConfirmComponent
    //directuve
    //UrlHrefDirective,
  ],
  providers: [
    // TelegramService
  ],
  bootstrap: [AppComponent]
})
export class AppModule {
  static injector: Injector;//DI 注入結構宣告
  constructor(
    injector: Injector//DI 注入結構宣告
  ) {
    AppModule.injector = injector;//DI 注入結構宣告
  }
}
